// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__14D-6","fileBtn":"File_fileBtn__3ONzE","closeBtn":"File_closeBtn__1rCjb","fileSelected":"File_fileSelected__21Ndp","disabled":"File_disabled__tNLBU"};